export enum FETCH_ACCOUNT_INFO {
  REQUESTED = 'ACCOUNT/FETCH_ACCOUNT_INFO_REQUESTED',
  SUCCESS = 'ACCOUNT/FETCH_ACCOUNT_INFO_SUCCESS',
  FAILED = 'ACCOUNT/FETCH_ACCOUNT_INFO_FAILED',
}

export enum FETCH_LOGIN_STATUS {
  REQUESTED = 'ACCOUNT/FETCH_LOGIN_STATUS_REQUESTED',
  SUCCESS = 'ACCOUNT/FETCH_LOGIN_STATUS_SUCCESS',
  FAILED = 'ACCOUNT/FETCH_LOGIN_STATUS_FAILED',
}

export enum BUSINESS_ACCOUNT_INFO {
  UPDATE = 'ACCOUNT/UPDATE_BUSINESS_ACCOUNT_INFO',
}
